export enum AppsConstants {
  APP_CREATE = 'APP_CREATE',
  APP_EDIT = 'APP_EDIT',
  APP_SCOPES = 'APP_SCOPES',
  APP_ENVIRONMENTS = 'APP_ENVIRONMENTS',
  APP_CATEGORIES = 'APP_CATEGORIES',
  APP_COUNTRIES = 'APP_COUNTRIES',
  APP_LOCALES = 'APP_LOCALES',
  APP_LIST_PRIVATE = 'APP_LIST_PRIVATE',
  APP_UNLIST_PRIVATE = 'APP_UNLIST_PRIVATE',
  APP_LOGO_SAVE = 'APP_LOGO_SAVE',
  APPS = 'APPS',
  APP = 'APP',
  APP_DELETE = 'APP_DELETE',
  APP_CREATE_NEW_VERSION = 'APP_CREATE_NEW_VERSION',
  GENERATE_SECRET = 'GENERATE_SECRET',
  APP_GET_HOOKS = 'APP_GET_HOOKS',
  APP_SAVE_HOOK = 'APP_SAVE_HOOK',
  APP_DELETE_HOOK = 'APP_DELETE_HOOK',
  APP_CREATE_NEW_LOCAL_HOOK = 'APP_CREATE_NEW_LOCAL_HOOK',
  APP_CHANGE_STATUS = 'APP_CHANGE_STATUS',
  APP_CHANGE_PRICING = 'APP_CHANGE_PRICING',
  APP_CHANGE_DISTRIBUTION = 'APP_CHANGE_DISTRIBUTION',
  APP_GET_HOOK_LOGS = 'APP_GET_HOOK_LOGS',
  APP_GET_HOOK_LOGS_STATISTICS = 'APP_GET_HOOK_LOGS_STATISTICS',
}

export enum AppHooks {
  HOOK = 'HOOK',
  HOOK_SAVE = 'HOOK_SAVE',
  HOOK_DELETE = 'HOOK_DELETE',
}
